<template>
  <v-dialog width="500" v-model="visibleModel">
    <v-card :loading="loading">
      <v-card-title>筛选</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <group-selector v-model="filters.group"/>
          <asin-selector v-model="filters.asin"/>
          <v-text-field label="关键词" v-model="filters.key"/>
          <market-selector v-model="filters.marketCode"/>
          <v-select label="类型" :items="types" v-model="filters.type" item-value="value"/>
          <v-row>
            <v-col cols="6" class="py-0 ma-0">
              <v-text-field label="排名 (最小值)" v-model="filters.minOrganicRank"/>
            </v-col>
            <v-col cols="6" class="py-0 ma-0">
              <v-text-field label="排名 (最大值)" v-model="filters.maxOrganicRank"/>
            </v-col>
            <v-col cols="6" class="py-0 ma-0">
              <v-text-field label="广告排名 (最小值)" v-model="filters.minSponsoredRank"/>
            </v-col>
            <v-col cols="6" class="py-0 ma-0">
              <v-text-field label="广告排名 (最大值)" v-model="filters.maxSponsoredRank"/>
            </v-col>
            <v-col cols="6" class="py-0 ma-0">
              <v-text-field label="搜索量 (最小值)" v-model="filters.minSearchVolume"/>
            </v-col>
            <v-col cols="6" class="py-0 ma-0">
              <v-text-field label="搜索量 (最大值)" v-model="filters.maxSearchVolume"/>
            </v-col>
            <v-col cols="6" class="py-0 ma-0">
              <v-text-field label="搜索趋势 (最小值)" v-model="filters.minSearchVolumeTrend"/>
            </v-col>
            <v-col cols="6" class="py-0 ma-0">
              <v-text-field label="搜索趋势 (最大值)" v-model="filters.maxSearchVolumeTrend"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field type="date" label="记录时间 (开始)" v-model="filters.beginDate"/>
            </v-col>
            <v-col cols="6">
              <v-text-field type="date" label="记录时间 (结束)" v-if="endDateEnabled" v-model="filters.endDate"/>
              <v-switch v-else v-model="endDateEnabled" label="记录时间 (结束)"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-switch v-model="filters.includePass" label="好汉非提当年勇"/>
            </v-col>
            <v-col cols="6">
              <v-switch v-model="filters.hasRemark" label="备注"/>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="warning" @click="reset">重置</v-btn>
        <v-spacer/>
        <v-btn text color="primary" @click="save">保存</v-btn>
        <v-btn text color="grey" @click="close">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MarketSelector from "@/components/MarketSelector";
import AsinSelector from "@/components/AsinSelector";
import GroupSelector from "@/components/GroupSelector";
export default {
  name: "KeywordFilterDialog",
  components: {GroupSelector, AsinSelector, MarketSelector},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    filters: Object
  },
  computed: {
    visibleModel: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val)
      }
    }
  },
  data() {
    return {
      loading: false,
      types: [
        {value: 0, text: "未设置"},
        {value: -1, text: "否定词"},
        {value: 1, text: "肯定词"},
      ],
      endDateEnabled: false,
    }
  },
  methods: {
    save() {
      this.close();
      this.$emit("reload");
    },
    reset() {
      this.filters.group = null;
      this.filters.asin = null;
      this.filters.key = null;
      this.filters.type = null;
      this.filters.minOrganicRank = null;
      this.filters.maxOrganicRank = null;
      this.filters.minSponsoredRank = null;
      this.filters.maxSponsoredRank = null;
      this.filters.minSearchVolume = null;
      this.filters.maxSearchVolume = null;
      this.filters.minSearchVolumeTrend = null;
      this.filters.maxSearchVolumeTrend = null;
      this.filters.beginDate = null;
      this.filters.endDate = null;
      this.filters.includesPass = false;
      this.filters.hasRemark = false;
      this.endDateEnabled = false;
    },
    close() {
      this.visibleModel = false;
    },
  },
  /*watch: {
    visible() {
      if (this.visible) {
        this.getAsins();
      }
    },
  }*/
}
</script>

<style scoped>

</style>